// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__IaFOK","validationTips":"StatementDescriptor_validationTips__1Gsmk"};